import React from "react";
import Button from "../../components/Button/Button";
import { FaTimes } from "react-icons/fa";

const ObservationsModal = ({
  isOpen,
  onClose,
  title = "Informations",
  content = "",
  allowHtml = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50 px-3">
      <div className="relative w-[95vw] max-w-2xl max-h-[80vh] overflow-hidden rounded-2xl bg-white dark:bg-slate-900 shadow-xl border border-slate-200/70 dark:border-slate-700/70">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200/70 dark:border-slate-700/70 bg-gradient-to-r from-primary to-primary/80 text-white">
          <h3 className="text-base sm:text-lg font-bold uppercase tracking-wide font-montserrat">
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="ml-2 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white text-sm"
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenu */}
        <div className="px-4 sm:px-5 py-4">
          <div className="max-h-[50vh] overflow-y-auto text-sm text-slate-800 dark:text-slate-100">
            {allowHtml ? (
              <div
                className="prose prose-sm dark:prose-invert max-w-none"
                dangerouslySetInnerHTML={{ __html: content || "<p>Aucun contenu</p>" }}
              />
            ) : (
              <div className="whitespace-pre-line leading-relaxed">
                {content || "Aucun contenu"}
              </div>
            )}
          </div>

          <div className="mt-4 flex justify-center pb-2">
            <Button
              onClick={onClose}
              className="btn-ghost flex items-center gap-2"
              text="Fermer"
              icon={FaTimes}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObservationsModal;